<a
    class="badge"
    fxLayout="row"
    fxLayoutAlign="start center"
    [class.header]="headerStyle"
    [routerLink]="linkToStation"
    (click)="badgeClicked.emit()"
    (keydown.enter)="badgeClicked.emit()"
    [matTooltip]="badgeTooltip$ | async"
    [matTooltipPosition]="'above'"
    [matTooltipClass]="'station-badge-tooltip'"
>
    <ng-container *ngIf="numberOfStations > 1; then multiple; else single"></ng-container>
</a>

<ng-template #single>
    <!-- Station icon -->
    <mat-icon svgIcon="ev-station-alt"></mat-icon>

    <!-- Station name & location -->
    <div fxFlex class="info" fxLayout="column">
        <span
            class="content"
            [attr.title]="
                station?.location?.name || globalSearchStation?.location?.locationName | ceCustomerPrivacy: 'location'
            "
        >
            {{ station?.name || globalSearchStation?.stationName | ceCustomerPrivacy: 'station' }}
        </span>
        <span>
            {{ description$ | async }}
        </span>
    </div>
</ng-template>

<ng-template #multiple>
    <!-- Station icon -->
    <mat-icon svgIcon="ev-station-alt"></mat-icon>

    <!-- Number of stations -->
    <div fxFlex class="info" fxLayout="column">
        <span class="content">{{ numberOfStations }} charging station selected</span>
    </div>
</ng-template>
